<template>
  <div style="max-width: 1000px; padding: 15px">
    <div v-if="showFiles">
      <div style="margin-left: 10px; font-weight: bold; margin-bottom: 10px">
        Files:
      </div>
      <ul>
        <!-- Labels Row -->
        <li class="labels-row">
          <span class="label-filename">Filename</span>
          <span class="label-hash">Hash</span>
        </li>

        <!-- File List -->
        <li
          v-for="file in files"
          :key="file.hash"
          @click="selectFile(file)"
          class="file-item"
        >
          <span class="filename">{{ file.filename }}</span>
          <span class="hash">{{ file.hash }}</span>
        </li>
      </ul>
      <div v-if="selectedFile" class="download-container">
        <input
          type="text"
          readonly
          :value="downloadLink"
          class="download-link"
          @focus="selectInputContent"
        />
      </div>
    </div>
    <div v-else>Loading...</div>
    <div v-if="downloadSuccess" class="download-success">
      Download successful! Please check your browser's downloads.
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from '@/axiosConfig'; // Adjust based on your axios configuration

const files = ref([]);
const selectedFile = ref(null);
const downloadLink = ref('');
const downloadSuccess = ref(false);

const urlParams = new URLSearchParams(window.location.search);
const showFiles = urlParams.has('showFiles');
const downloadHash = urlParams.get('hash');

async function fetchFiles() {
  try {
    const response = await axios.get('/files');
    files.value = response.data;
  } catch (error) {
    console.error('Error fetching files:', error);
  }
}

function selectFile(file) {
  selectedFile.value = file;
  const { hostname, port } = window.location;
  const baseUrl = `${window.location.protocol}//${hostname}${port ? `:${port}` : ''}`;
  downloadLink.value = `${baseUrl}/download?hash=${file.hash}`;
}

async function downloadFile(hash) {
  console.log('Downloading file with hash:', hash);
  try {
    const response = await axios.get(`/download?hash=${hash}`, {
      responseType: 'blob',
    });
    const blob = new Blob([response.data], {
      type: response.headers['content-type'],
    });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = response.headers['content-disposition']
      .split('filename=')[1]
      .replace(/"/g, '');
    link.click();
    downloadSuccess.value = true;
  } catch (error) {
    console.error('Error downloading file:', error);
  }
}

function selectInputContent(event) {
  event.target.select();
}

onMounted(async () => {
  document.title = 'downloads';
  if (showFiles) {
    await fetchFiles(); // Await the fetchFiles function
  }

  if (downloadHash) {
    await downloadFile(downloadHash); // Await the downloadFile function
  }
});
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}

.labels-row {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 10px;
  background-color: #f2f2f2;
  border-bottom: 1px solid #ccc;
}

.label-filename,
.label-hash {
  flex: 1;
}

li {
  cursor: pointer;
  margin: 5px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  padding: 10px;
}

.filename {
  flex: 1;
  font-weight: bold;
}

.hash {
  flex: 2;
  color: #555;
}

.download-container {
  margin-top: 20px;
}

.download-link {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.download-success {
  margin-top: 20px;
  padding: 10px;
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
}
</style>
